<template>
  <div class='EnbItemBtn'>
    <button @click="Push"
    v-if="data.tipo !== 'Variável'"
    :disabled="data.gerEstoque && data.estoque <= 0 && data.tipo !== 'Variável'"
    :style="{
      backgroundColor: Prefes.btnProduto.corBackground,
      fontFamily: Prefes.btnProduto.font,
      color: Prefes.btnProduto.corFont,
      fontStyle: parseInt(Prefes.btnProduto.fontStyle) ? 'italic' : '',
      fontWeight: parseInt(Prefes.btnProduto.fontBold) ? 'bold' : '',
      textDecoration: parseInt(Prefes.btnProduto.textDecoration) ? 'underline' : '',
      fontSize: Prefes.btnProduto.fontHeight + 'px'
    }"
    >
      Comprar
    </button>
    <button @click="Push"
    v-if="data.tipo === 'Variável'"
    :style="{
      backgroundColor: Prefes.btnProduto.corBackground,
      fontFamily: Prefes.btnProduto.font,
      color: Prefes.btnProduto.corFont,
      fontStyle: parseInt(Prefes.btnProduto.fontStyle) ? 'italic' : '',
      fontWeight: parseInt(Prefes.btnProduto.fontBold) ? 'bold' : '',
      textDecoration: parseInt(Prefes.btnProduto.textDecoration) ? 'underline' : '',
      fontSize: Prefes.btnProduto.fontHeight + 'px'
    }"
    >
      Comprar
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'EnbItemBtn',
  props: ['data'],
  computed: {
    ...mapGetters(['Prefes']),
    estoqueVariavel () {
      return this.data.estoqueVariavel.map(e => e.src.quantidade).reduce((p, c) => parseFloat(c) + parseFloat(p), 0)
    }
  },
  methods: {
    ...mapActions(['ToggleCheckout01', 'PushCheckout01', 'SetItem01']),
    Push () {
      if(this.data.tipo === 'Variável') {
        this.SetItem01(this.data)
          .then( async () => {
            if(typeof this.$route.params.categ !== 'undefined') {
              this.$router.push(`/loja/${this.$route.params.categ}/${this.data.link}`)
            } else {
              this.$router.push(`/${this.data.link}`)
            }
          })
        return
      }
      this.PushCheckout01({ item: this.data, qtda: 1 })
      this.ToggleCheckout01(true)
    }
  }
}
</script>

<style scoped>
.EnbItemBtn {
  width: 100%;
  height: 100%;
}

button {
  border: 0;
  color: #FFFFFF;
  background-color: #4E7826;
  padding: 4%;
  border-radius: 5px;
  cursor: pointer;
}

button:disabled {
  opacity: 0.50;
}
</style>
